import { render } from "./RegisterStepOne.vue?vue&type=template&id=a46a94f8"
import script from "./RegisterStepOne.vue?vue&type=script&lang=js"
export * from "./RegisterStepOne.vue?vue&type=script&lang=js"
script.render = render

export default script